import React, { useEffect, useState } from "react";
import Map from "./Map";
import { fetchVillageDetails } from "./api";

function App() {
  const [villages, setVillages] = useState([]);
  const [attacks, setAttacks] = useState([]);

  useEffect(() => {
    const loadVillages = async () => {
      const villageData = await fetchVillageDetails();

      // Create a mapping of villages with details
      const villageMap = {};
      const attackList = [];

      villageData.forEach((village) => {
        const { id, food, huts, lumberCamps, level, score, villagers,wood, player } = village;
        
        // Generate a random position for each village (this can be adjusted)
        const position = [Math.random() * 100 - 50, Math.random() * 100 - 50];

        // Store village details
        villageMap[id] = {
          id,
          name: `Village ${id}`,
          position,
          food,
          huts,
          lumberCamps,
          level,
          score,
          villagers,
          playerUsername: player.username,
          playerPic: player.pfp,
          wood
        };
        
        // Add to the attack list for demonstration purposes
        attackList.push({
          from: position,  // Example source position
          to: [position[0] + 10, position[1] + 10], // Example target position
        });
      });

      setVillages(Object.values(villageMap));
      setAttacks(attackList);
    };

    loadVillages();
  }, []);

  return (
    <div className="App">
      <Map villages={villages} />
    </div>
  );
}

export default App;
